import dynamic from 'next/dynamic';
import ClientPageFooter from '@/common/appRouter/ClientPageFooter';
import BudgetFriendlyCarousel from '@/common/BudgetFriendlyCarousel/BudgetFriendlyCarousel';
import PopularBodyStyles from '@/common/PopularBodyStyles/PopularBodyStyles';
import ShopPopularModels from '@/common/ShopPopularModels/ShopPopularModels';
import { Consumer } from '~/constants/common/consumer';
import { defaultDeviceType } from '~/constants/common/defaultDeviceType';
import { DeviceContextProvider } from '~/context/common/DeviceContext';
import {
  generateStaticContext,
  StaticContextProvider
} from '~/context/common/StaticContext';
import { useIsDealershipPage } from '~/context/dealership/StaticContext';
import type { NativeDeviceType } from '~/contracts/common';
import DealershipNotFoundHero from './DealershipNotFoundHero';
import NotFoundDeviceSync from './NotFoundDeviceSync';
import NotFoundHero from './NotFoundHero';

const DealershipPageFooter = dynamic(
  () =>
    import(
      /* webpackChunkName: "DealershipPageFooter" */ '@/dealership/PageFooter'
    )
);

const staticContext = generateStaticContext({ consumer: Consumer.ERROR_PAGE });

type OwnProps = {
  nativeDeviceType?: NativeDeviceType;
};

export default function NotFoundExperience({ nativeDeviceType }: OwnProps) {
  const isDealership = useIsDealershipPage();

  return (
    <StaticContextProvider {...staticContext}>
      <DeviceContextProvider
        {...defaultDeviceType}
        nativeDeviceType={
          nativeDeviceType ?? defaultDeviceType.nativeDeviceType
        }
      >
        <NotFoundDeviceSync />
        <div className="mx-auto max-w-[1800px] bg-background-weak">
          {isDealership ? (
            <DealershipNotFoundHero />
          ) : (
            <>
              <NotFoundHero />
              <PopularBodyStyles hasBackground={false} hasTopSpacing whiteBg />
              <BudgetFriendlyCarousel hasBackground={false} />
              <ShopPopularModels hasBackground={false} whiteBg />
            </>
          )}
        </div>
        {!nativeDeviceType?.isNative &&
          (isDealership ? (
            <DealershipPageFooter />
          ) : (
            <ClientPageFooter className="bg-background-weak" />
          ))}
      </DeviceContextProvider>
    </StaticContextProvider>
  );
}
